import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/CrtRelatedMics';

const CrtRelatedMicsPage = () => {
  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default CrtRelatedMicsPage;
